export const loadProjects = async (language: string): Promise<any[]> => {
    try {
      // Adjust the path if you store your JSON differently
      const projects = await import(`./${language}/projects.json`);
      // `projects.default` is the actual data from JSON
      return projects.default;
    } catch (error) {
      console.error(`Error loading projects for language: ${language}`, error);
      return [];
    }
};
